import { render, staticRenderFns } from "./ShowFileComponent.vue?vue&type=template&id=79c71bfa&"
import script from "./ShowFileComponent.vue?vue&type=script&lang=js&"
export * from "./ShowFileComponent.vue?vue&type=script&lang=js&"
import style0 from "./ShowFileComponent.vue?vue&type=style&index=0&id=79c71bfa&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports